export default "data:image/gif;base64,R0lGODlhEAAQAJEDAIGBgXJycv///////yH5BAEAAAMALAAAAAAQABAAAAIrnI95wc1qgpg0ACjplDdl7XjaGIhjZZ5CiXwnu6hb+tKkDeJo6/QwBBwUAAA7"